function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { adaptDashRole, AudioRole, hasAudioDescriptionRole } from '../../core/player/role';
import { CvsdkError, ErrorSeverity } from '../../error';
import { sdkLogger } from '../../logger';
import { isBetterAudioTrack } from '../../utils/audio-utils';
import { compareIso639LanguageCodes, extractIso639LanguageCode } from '../../utils/iso639-language-helper';
import { areCodecsCompatible } from '../../utils/probe-utils';
import { arraysAreEqual } from '../../utils/array-utils';
export var ShakaAudioTracksManager = /*#__PURE__*/ function() {
    "use strict";
    function ShakaAudioTracksManager(player, options) {
        var _this = this;
        _class_call_check(this, ShakaAudioTracksManager);
        _define_property(this, "player", void 0);
        _define_property(this, "options", void 0);
        _define_property(this, "_clientFacingTracks", void 0);
        _define_property(this, "_isCodecSwitching", void 0);
        _define_property(this, "_lastSetAudioTrackId", void 0);
        _define_property(this, "_logger", void 0);
        _define_property(this, "_variantTracks", void 0);
        _define_property(this, "getAvailableLanguages", void 0);
        this.player = player;
        this.options = options;
        this._clientFacingTracks = [];
        this._isCodecSwitching = false;
        this._lastSetAudioTrackId = null;
        this._variantTracks = [];
        this.getAvailableLanguages = function() {
            return _to_consumable_array(new Set(_this._variantTracks.map(function(track) {
                return track.language;
            })));
        };
        this._logger = sdkLogger.withContext('ShakaAudioTracksManager');
    }
    _create_class(ShakaAudioTracksManager, [
        {
            key: "isCodecSwitching",
            get: function get() {
                return this._isCodecSwitching;
            }
        },
        {
            key: "lastSetAudioTrackId",
            get: function get() {
                return this._lastSetAudioTrackId;
            }
        },
        {
            key: "variantTracks",
            get: function get() {
                if (this._variantTracks.length === 0) {
                    this.setVariantTracks(this.player.getVariantTracks());
                }
                return this._variantTracks;
            }
        },
        {
            key: "buildReducedAudioTrackList",
            value: function buildReducedAudioTrackList() {
                var adapter = this.options.optimiseAudioTracksByLanguage ? this.reduceAudioTrackList.bind(this) : this.convertToCvsdkTracks.bind(this);
                this._clientFacingTracks = adapter();
                return this._clientFacingTracks;
            }
        },
        {
            key: "convertToCvsdkTracks",
            value: function convertToCvsdkTracks() {
                return this.variantTracks.map(this.adaptVariantTrackToAudioTrack).filter(function(track, index, self) {
                    return self.map(function(item) {
                        return item.id;
                    }).indexOf(track.id) == index;
                });
            }
        },
        {
            key: "reduceAudioTrackList",
            value: function reduceAudioTrackList() {
                var bestTrackPerLanguage = this.getBestTrackPerLanguage();
                var currentActiveTrack = this.getActiveExactAudioTrack();
                if (currentActiveTrack) {
                    var activeKey = this.buildAudioTrackKey(currentActiveTrack);
                    var bestTrackWithActiveLanguage = bestTrackPerLanguage.get(activeKey);
                    var audioIdField = bestTrackWithActiveLanguage && bestTrackWithActiveLanguage.rawTrack.audioId ? 'audioId' : 'originalAudioId';
                    if (bestTrackWithActiveLanguage && bestTrackWithActiveLanguage.rawTrack[audioIdField] !== currentActiveTrack[audioIdField]) {
                        this._logger.warn("Unexpected active audio track (codec: ".concat(currentActiveTrack.audioCodec, ", channels: ").concat(currentActiveTrack.channelsCount, ")                 with candidate (codec: ").concat(bestTrackWithActiveLanguage.sdkTrack.audioCodec, ", channels: ").concat(bestTrackWithActiveLanguage.sdkTrack.channelsCount, ")"));
                        bestTrackPerLanguage.set(activeKey, {
                            sdkTrack: this.adaptVariantTrackToAudioTrack(currentActiveTrack),
                            rawTrack: currentActiveTrack
                        });
                    }
                }
                this._clientFacingTracks = Array.from(bestTrackPerLanguage.values()).map(function(t) {
                    return t.sdkTrack;
                });
                return this._clientFacingTracks;
            }
        },
        {
            key: "getActiveAudioTrack",
            value: function getActiveAudioTrack() {
                var activeId = this.getActiveExactAudioTrackId();
                if (!activeId) {
                    return;
                }
                return this.getClosestReducedMatch(activeId);
            }
        },
        {
            key: "getActiveAudioTrackId",
            value: function getActiveAudioTrackId() {
                var _this_adaptVariantTrackToAudioTrack_id;
                var activeAudioTrack = this.getActiveAudioTrack();
                if (!activeAudioTrack) return undefined;
                return (_this_adaptVariantTrackToAudioTrack_id = this.adaptVariantTrackToAudioTrack(activeAudioTrack).id) === null || _this_adaptVariantTrackToAudioTrack_id === void 0 ? void 0 : _this_adaptVariantTrackToAudioTrack_id.toString();
            }
        },
        {
            key: "getClosestReducedMatch",
            value: function getClosestReducedMatch(id) {
                var _this = this;
                if (!id) {
                    return;
                }
                if (this._clientFacingTracks.length === 0) {
                    this.buildReducedAudioTrackList();
                }
                var exactTrack = this.getAudioTrackForTrackId(id);
                if (!exactTrack) {
                    return;
                }
                var exactCvsdkTrack = this.adaptVariantTrackToAudioTrack(exactTrack);
                var clientTrack = this._clientFacingTracks.find(function(t) {
                    return _this.options.omitRegionCodeFromAudioTrack ? compareIso639LanguageCodes(t.languageTag, exactCvsdkTrack.languageTag) && t.label === exactCvsdkTrack.label && arraysAreEqual(t.roles, exactCvsdkTrack.roles) : t.languageTag === exactCvsdkTrack.languageTag && t.label === exactCvsdkTrack.label && arraysAreEqual(t.roles, exactCvsdkTrack.roles);
                });
                if (!clientTrack) {
                    this._logger.warn("Could not find client facing track for ".concat(id));
                    return;
                }
                return this.variantTracks.find(function(t) {
                    return _this.adaptVariantTrackToAudioTrack(t).id == clientTrack.id;
                });
            }
        },
        {
            key: "getLastSelectedAudioTrack",
            value: function getLastSelectedAudioTrack() {
                if (this._lastSetAudioTrackId) {
                    return this.getAudioTrackForTrackId(this._lastSetAudioTrackId);
                }
                return undefined;
            }
        },
        {
            key: "handlePaused",
            value: function handlePaused() {
                // If pause event is triggered, switching codec and related buffering definitely have ended.
                this.resetCodecSwitch();
            }
        },
        {
            key: "handlePlaying",
            value: function handlePlaying() {
                // If playing event is triggered, switching codec and related buffering definitely have ended.
                this.resetCodecSwitch();
            }
        },
        {
            key: "resetCodecSwitch",
            value: function resetCodecSwitch() {
                this._isCodecSwitching = false;
            }
        },
        {
            key: "setMultiviewAudioTrack",
            value: function setMultiviewAudioTrack(activeAudioTrack, clientFacingDesiredTrack, audioTrack) {
                if (this.options.isSafari) {
                    var // selectVariantsByLabel does not currently work on Safari so use selectVariantTrack instead
                    _this_player;
                    (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.selectVariantTrack(audioTrack, true);
                } else {
                    var /* safeMargin= */ _this_player_getConfiguration_abr, _this_player1, _this_player2;
                    var _this_player_getConfiguration_abr_safeMarginSwitch;
                    (_this_player2 = this.player) === null || _this_player2 === void 0 ? void 0 : _this_player2.selectVariantsByLabel(audioTrack.label || '', /* clearBuffer= */ true, (_this_player_getConfiguration_abr_safeMarginSwitch = (_this_player1 = this.player) === null || _this_player1 === void 0 ? void 0 : (_this_player_getConfiguration_abr = _this_player1.getConfiguration().abr) === null || _this_player_getConfiguration_abr === void 0 ? void 0 : _this_player_getConfiguration_abr.safeMarginSwitch) !== null && _this_player_getConfiguration_abr_safeMarginSwitch !== void 0 ? _this_player_getConfiguration_abr_safeMarginSwitch : 0, /* switchVideo= */ false);
                }
                var _activeAudioTrack_language, _clientFacingDesiredTrack_language;
                // if the languages are not compatible, change the prefetched language
                if (!shaka.util.LanguageUtils.areLanguageCompatible((_activeAudioTrack_language = activeAudioTrack === null || activeAudioTrack === void 0 ? void 0 : activeAudioTrack.language) !== null && _activeAudioTrack_language !== void 0 ? _activeAudioTrack_language : '', (_clientFacingDesiredTrack_language = clientFacingDesiredTrack === null || clientFacingDesiredTrack === void 0 ? void 0 : clientFacingDesiredTrack.language) !== null && _clientFacingDesiredTrack_language !== void 0 ? _clientFacingDesiredTrack_language : '')) {
                    var _this_player3;
                    (_this_player3 = this.player) === null || _this_player3 === void 0 ? void 0 : _this_player3.configure('streaming.prefetchAudioLanguages', [
                        audioTrack.language
                    ]);
                }
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(audioTrackId) {
                var safeMargin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var _config_mediaSource;
                var audioTrack = this.getAudioTrackForTrackId(audioTrackId);
                if (!audioTrack) {
                    throw CvsdkError.from({
                        code: "SHAKA_AUDIO_TRACK_NOT_FOUND",
                        message: "Failed to set audio track ".concat(audioTrackId, " - could not determine audio track"),
                        severity: ErrorSeverity.Warning
                    });
                }
                var clientFacingActive = this.getClosestReducedMatch(this.getActiveExactAudioTrackId());
                var clientFacingDesired = this.getClosestReducedMatch(audioTrackId);
                if (clientFacingActive && clientFacingDesired && clientFacingActive === clientFacingDesired) {
                    this._logger.info("Audio track id ".concat(audioTrackId, " already active"));
                    return;
                }
                var config = this.player.getConfiguration();
                this.determineCodecSwitch(audioTrack, config === null || config === void 0 ? void 0 : (_config_mediaSource = config.mediaSource) === null || _config_mediaSource === void 0 ? void 0 : _config_mediaSource.codecSwitchingStrategy);
                var preferredAudioChannelCount = config.preferredAudioChannelCount;
                if (this.options.isMultiview) {
                    this.setMultiviewAudioTrack(clientFacingActive, clientFacingDesired, audioTrack);
                } else {
                    var _this_player;
                    (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.selectAudioLanguage(audioTrack.language, audioTrack.roles[0], audioTrack.channelsCount || preferredAudioChannelCount, safeMargin, audioTrack.audioCodec || '');
                }
                this._lastSetAudioTrackId = audioTrackId;
            }
        },
        {
            key: "setVariantTracks",
            value: function setVariantTracks(tracks) {
                var _this = this;
                this._variantTracks = tracks.filter(function(track) {
                    if (track.audioCodec && !_this.isPlayable(track)) {
                        return false;
                    }
                    return true;
                });
            }
        },
        {
            key: "adaptVariantTrackToAudioTrack",
            value: function adaptVariantTrackToAudioTrack(variantTrack) {
                var _variantTrack_audioId;
                var roles = variantTrack.roles.map(function(role) {
                    return adaptDashRole(role);
                });
                var audioBitrateKbps = variantTrack.audioBandwidth && variantTrack.audioBandwidth / 1000;
                var _variantTrack_originalLanguage;
                return {
                    // Fallback added here in the rare event, particularly on Safari, when audioId is not set
                    id: ((_variantTrack_audioId = variantTrack.audioId) === null || _variantTrack_audioId === void 0 ? void 0 : _variantTrack_audioId.toString()) || variantTrack.originalAudioId,
                    name: variantTrack.label || variantTrack.originalLanguage,
                    label: variantTrack.label,
                    language: extractIso639LanguageCode((_variantTrack_originalLanguage = variantTrack.originalLanguage) !== null && _variantTrack_originalLanguage !== void 0 ? _variantTrack_originalLanguage : ''),
                    languageTag: variantTrack.originalLanguage,
                    roles: roles,
                    audioCodec: variantTrack.audioCodec,
                    audioBitrateKbps: audioBitrateKbps,
                    channelsCount: variantTrack.channelsCount,
                    isAudioDescription: hasAudioDescriptionRole(roles)
                };
            }
        },
        {
            key: "buildAudioTrackKey",
            value: function buildAudioTrackKey(track) {
                var role = track.roles[0] ? adaptDashRole(track.roles[0]) : AudioRole.Main;
                var _track_originalLanguage;
                var lang = (_track_originalLanguage = track.originalLanguage) !== null && _track_originalLanguage !== void 0 ? _track_originalLanguage : 'unknown';
                return "".concat(lang, ":").concat(role, ";");
            }
        },
        {
            key: "determineCodecSwitch",
            value: function determineCodecSwitch(audioTrack, codecSwitchingStrategy) {
                var currentTrack = this.getActiveExactAudioTrack();
                var isReload = codecSwitchingStrategy === 'reload';
                if (currentTrack && isReload && !areCodecsCompatible(audioTrack.audioCodec, currentTrack.audioCodec)) {
                    this._isCodecSwitching = true;
                }
            }
        },
        {
            key: "getActiveExactAudioTrack",
            value: function getActiveExactAudioTrack() {
                var activeId = this.getActiveExactAudioTrackId();
                if (!activeId) {
                    return;
                }
                return this.getAudioTrackForTrackId(activeId);
            }
        },
        {
            key: "getActiveExactAudioTrackId",
            value: function getActiveExactAudioTrackId() {
                var activeId = undefined;
                var firstActiveAudioTrackId = this.getFirstActiveAudioTrackId();
                // On Safari, all audio tracks are marked as active, so the first track is always selected here
                // Check to see if the last user selected track is active and return its ID if that is the case
                // otherwise, fallback to finding the first active track
                if (this.isLastSelectedAudioTrackActive()) {
                    // @ts-ignore
                    activeId = this.lastSetAudioTrackId;
                } else {
                    activeId = firstActiveAudioTrackId;
                }
                if (activeId) {
                    return activeId;
                }
                if (!firstActiveAudioTrackId && this.lastSetAudioTrackId) {
                    // Handles edge case when active audio track is never selected on some streams.
                    activeId = this.lastSetAudioTrackId;
                }
                return activeId;
            }
        },
        {
            key: "getAudioTrackForTrackId",
            value: function getAudioTrackForTrackId(trackId) {
                var _this = this;
                var _this_variantTracks;
                return (_this_variantTracks = this.variantTracks) === null || _this_variantTracks === void 0 ? void 0 : _this_variantTracks.find(function(variantTrack) {
                    return _this.adaptVariantTrackToAudioTrack(variantTrack).id === trackId;
                });
            }
        },
        {
            key: "getBestTrackPerLanguage",
            value: function getBestTrackPerLanguage() {
                var _this = this;
                var adaptedAudioTracks = this.variantTracks.reduce(function(bestTrackPerLanguage, variant) {
                    var key = _this.buildAudioTrackKey(variant);
                    var previousMatch = bestTrackPerLanguage.get(key);
                    if (!previousMatch || variant.active || isBetterAudioTrack(variant, previousMatch.rawTrack)) {
                        var track = _this.adaptVariantTrackToAudioTrack(variant);
                        bestTrackPerLanguage.set(key, {
                            rawTrack: variant,
                            sdkTrack: track
                        });
                    }
                    return bestTrackPerLanguage;
                }, new Map());
                return adaptedAudioTracks;
            }
        },
        {
            key: "getFirstActiveAudioTrackId",
            value: function getFirstActiveAudioTrackId() {
                var _this_adaptVariantTrackToAudioTrack_id, _this_adaptVariantTrackToAudioTrack;
                var activeTrack = this.variantTracks.find(function(track) {
                    return track.active;
                });
                if (!activeTrack) return undefined;
                return (_this_adaptVariantTrackToAudioTrack = this.adaptVariantTrackToAudioTrack(activeTrack)) === null || _this_adaptVariantTrackToAudioTrack === void 0 ? void 0 : (_this_adaptVariantTrackToAudioTrack_id = _this_adaptVariantTrackToAudioTrack.id) === null || _this_adaptVariantTrackToAudioTrack_id === void 0 ? void 0 : _this_adaptVariantTrackToAudioTrack_id.toString();
            }
        },
        {
            key: "isLastSelectedAudioTrackActive",
            value: function isLastSelectedAudioTrackActive() {
                if (!this._lastSetAudioTrackId) {
                    return false;
                }
                var trackForLastSelectedId = this.getAudioTrackForTrackId(this._lastSetAudioTrackId);
                return Boolean(trackForLastSelectedId === null || trackForLastSelectedId === void 0 ? void 0 : trackForLastSelectedId.active);
            }
        },
        {
            key: "isPlayable",
            value: function isPlayable(track) {
                var config = this.player.getConfiguration();
                var _config_preferredAudioCodecs;
                var preferredAudioCodecs = (_config_preferredAudioCodecs = config.preferredAudioCodecs) !== null && _config_preferredAudioCodecs !== void 0 ? _config_preferredAudioCodecs : [];
                if (track.audioCodec && preferredAudioCodecs.length > 0 && !preferredAudioCodecs.includes(track.audioCodec)) {
                    return false;
                }
                var _track_channelsCount;
                if (config.preferredAudioChannelCount && ((_track_channelsCount = track.channelsCount) !== null && _track_channelsCount !== void 0 ? _track_channelsCount : 0) > config.preferredAudioChannelCount) {
                    return false;
                }
                return true;
            }
        }
    ]);
    return ShakaAudioTracksManager;
}();

//# sourceMappingURL=shaka-audio-tracks-manager.js.map